import React from "react";
// import "./NoBooking.scss";
import { useNavigate } from "react-router-dom";

const NoBooking = () => {
  const navigate = useNavigate();
  return (
    <div className="no-games-container">
      {/* <h1 className="heading"> Greatness is reserved for those who show up.</h1> */}
      <p className="subtextMain">
        Greatness is reserved for those who show up.
      </p>
      <br />
      <p className="subtext">
        Courts are waiting, competition is ready, what’s stopping you?
      </p>
      <button
        className="book-game-btn"
        onClick={() => {
          navigate("/dashboard/reserve");
        }}
      >
        Find a court & Play!
      </button>
    </div>
  );
};

export default NoBooking;
